import { useEffect, useState } from "react";
import { fetchFundsCenters, downloadFundsCentersExcel } from "../Api/ViewFundsCenter";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const ViewFundsCenter = () => {
  const [fundsCenters, setFundsCenters] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadFundsCenters = async () => {
      try {
        const data = await fetchFundsCenters();
        setFundsCenters(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Funds Centers`);
      }
    };

    loadFundsCenters();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadFundsCentersExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'FundsCenters_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Funds Centers data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="list-container">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <span className="list-title">View Funds Centers</span>
              <Button className="generate-btn"
                variant="primary" 
                onClick={handleDownload}
                disabled={isDownloading || fundsCenters.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>

            {fundsCenters.length > 0 ? (
              <div className="table-wrapper">
                <div className="table-scroll-container">
                  <Table bordered hover className="data-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Code</th>
                        <th>Name</th>
                        <th>STPL</th>
                        <th>Created At</th>
                        <th>Created By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fundsCenters.map((fundsCenter, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{fundsCenter.code}</td>
                          <td>{fundsCenter.name}</td>
                          <td>{fundsCenter.stpl}</td>
                          <td>{moment(fundsCenter.createdAt).format('L')} at {moment(fundsCenter.createdAt).format('LTS')}</td>
                          <td>{fundsCenter.createdBy}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            ) : (
              <p className="no-data">No funds centers found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewFundsCenter;